import React from "react";
import style from "./QuestionItem.module.scss";
import QuestionItem from "pages/homework/component/questionItem";
import { IQuestion } from "pages/homework";
import { getExamTypeString, toFixedNumber } from "pages/homework/utils/filter";

interface MQuestionItemProps {
    index: number;
    data: IQuestion;
    state: number;
    empty: boolean; // 已废弃属性. 试题组件非受控, 销毁会丢失状态
    showHeader?: boolean;
    canPastedText?: boolean;
    onQuestionChange: (
        topicId: number,
        topicType: string,
        answerId: number | number[],
        value?: string,
        userAnswers?: any
    ) => void;
}

export default React.memo(function MQuestionItem({
    index,
    state,
    data,
    empty,
    showHeader = true,
    canPastedText = true,
    onQuestionChange
}: MQuestionItemProps) {
    return (
        <div className={style.root}>
            {showHeader && (
                <div className={style.header}>
                    {index + 1}.{getExamTypeString(data.topicType)}题{" "}
                    <span className={style.score}>
                        ({toFixedNumber(data.score)}分)
                    </span>
                </div>
            )}

            <div
                className={data.topicType === "4" ? style.padding : ""}
                id={data.topicId.toString()}>
                <QuestionItem
                    item={data}
                    canPastedText={canPastedText}
                    topicId={data.topicId}
                    topicType={data.topicType}
                    trunk={data.trunk}
                    answers={data.answers}
                    homeworkState={state}
                    onQuestionChange={onQuestionChange}
                    contentText={data.contentText}
                    topics={data.topics}
                    comment={!!data.comment ? data.comment : ""}
                />
            </div>
        </div>
    );
});
